module.exports = "<div class=\"container\">\n  <div class=\"pull-right\">\n      <h3><span class=\"label label-danger\"> {{companyName}}</span></h3>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/usr/clienti.qmedical/src/app/full-layout/header/header.component.html
// module id = ../../../../../src/app/full-layout/header/header.component.html
// module chunks = main